// @generated by protoc-gen-es v1.9.0 with parameter "target=ts"
// @generated from file no/jotta/openapi/content/v2/content.v2.proto (package no.jotta.openapi.content.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3 } from "@bufbuild/protobuf";
import { ContentRef } from "../../ref_pb.js";
/**
 * @generated from message no.jotta.openapi.content.v2.DownloadLocationRequest
 */
export class DownloadLocationRequest extends Message {
    /**
     * @generated from oneof no.jotta.openapi.content.v2.DownloadLocationRequest.ref
     */
    ref = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.content.v2.DownloadLocationRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "plain", kind: "message", T: ContentRef, oneof: "ref" },
        { no: 2, name: "encoded_ref", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "ref" },
    ]);
    static fromBinary(bytes, options) {
        return new DownloadLocationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DownloadLocationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DownloadLocationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DownloadLocationRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.content.v2.DownloadLocationResponse
 */
export class DownloadLocationResponse extends Message {
    /**
     * @generated from oneof no.jotta.openapi.content.v2.DownloadLocationResponse.result
     */
    result = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.content.v2.DownloadLocationResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "located", kind: "message", T: DownloadLocationResponse_Located, oneof: "result" },
        { no: 2, name: "not_found", kind: "message", T: DownloadLocationResponse_NotFound, oneof: "result" },
        { no: 3, name: "not_supported", kind: "message", T: DownloadLocationResponse_NotSupported, oneof: "result" },
        { no: 4, name: "access_denied", kind: "message", T: DownloadLocationResponse_AccessDenied, oneof: "result" },
        { no: 5, name: "account_locked", kind: "message", T: DownloadLocationResponse_AccountLocked, oneof: "result" },
    ]);
    static fromBinary(bytes, options) {
        return new DownloadLocationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DownloadLocationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DownloadLocationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DownloadLocationResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.content.v2.DownloadLocationResponse.Located
 */
export class DownloadLocationResponse_Located extends Message {
    /**
     * @generated from field: string url = 1;
     */
    url = "";
    /**
     * @generated from field: optional int64 size = 2;
     */
    size;
    /**
     * @generated from field: optional string md5 = 3;
     */
    md5;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.content.v2.DownloadLocationResponse.Located";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "size", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
        { no: 3, name: "md5", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    ]);
    static fromBinary(bytes, options) {
        return new DownloadLocationResponse_Located().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DownloadLocationResponse_Located().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DownloadLocationResponse_Located().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DownloadLocationResponse_Located, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.content.v2.DownloadLocationResponse.NotFound
 */
export class DownloadLocationResponse_NotFound extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.content.v2.DownloadLocationResponse.NotFound";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new DownloadLocationResponse_NotFound().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DownloadLocationResponse_NotFound().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DownloadLocationResponse_NotFound().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DownloadLocationResponse_NotFound, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.content.v2.DownloadLocationResponse.NotSupported
 */
export class DownloadLocationResponse_NotSupported extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.content.v2.DownloadLocationResponse.NotSupported";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new DownloadLocationResponse_NotSupported().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DownloadLocationResponse_NotSupported().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DownloadLocationResponse_NotSupported().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DownloadLocationResponse_NotSupported, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.content.v2.DownloadLocationResponse.AccessDenied
 */
export class DownloadLocationResponse_AccessDenied extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.content.v2.DownloadLocationResponse.AccessDenied";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new DownloadLocationResponse_AccessDenied().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DownloadLocationResponse_AccessDenied().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DownloadLocationResponse_AccessDenied().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DownloadLocationResponse_AccessDenied, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.content.v2.DownloadLocationResponse.AccountLocked
 */
export class DownloadLocationResponse_AccountLocked extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.content.v2.DownloadLocationResponse.AccountLocked";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new DownloadLocationResponse_AccountLocked().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DownloadLocationResponse_AccountLocked().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DownloadLocationResponse_AccountLocked().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DownloadLocationResponse_AccountLocked, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.content.v2.DownloadLocationsRequest
 */
export class DownloadLocationsRequest extends Message {
    /**
     * @generated from field: repeated no.jotta.openapi.content.v2.DownloadLocationRequest downloads = 1;
     */
    downloads = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.content.v2.DownloadLocationsRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "downloads", kind: "message", T: DownloadLocationRequest, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new DownloadLocationsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DownloadLocationsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DownloadLocationsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DownloadLocationsRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.content.v2.DownloadLocationsResponse
 */
export class DownloadLocationsResponse extends Message {
    /**
     * @generated from field: repeated no.jotta.openapi.content.v2.DownloadLocationResponse locations = 1;
     */
    locations = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.content.v2.DownloadLocationsResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "locations", kind: "message", T: DownloadLocationResponse, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new DownloadLocationsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DownloadLocationsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DownloadLocationsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DownloadLocationsResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.content.v2.PrepareDownloadRequest
 */
export class PrepareDownloadRequest extends Message {
    /**
     * @generated from field: repeated no.jotta.openapi.content.v2.DownloadLocationRequest elements = 1;
     */
    elements = [];
    /**
     * @generated from field: string name = 2;
     */
    name = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.content.v2.PrepareDownloadRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "elements", kind: "message", T: DownloadLocationRequest, repeated: true },
        { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new PrepareDownloadRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PrepareDownloadRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PrepareDownloadRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PrepareDownloadRequest, a, b);
    }
}
